<template>
  <div class="job-content-create">
    <common-card title="Pallet Search Form" class="groups">
      <search-form
        :search-form="searchForm"
        :search-form-change="searchParamChange"
      />
    </common-card>
    <el-transfer
      filterable
      v-model="selectedPallets"
      :data="palletList"
      :titles="['Pallet List', 'Job Content']"
      v-loading="loadingPalletList"
    >
      <div class="item-label" slot-scope="{ option }">
        <div class="first-row">
          <span>{{ option.deliveryAddress }}</span>
          <span v-if="option.hold">Hold</span>
          <span>{{ option.priority }}</span>
        </div>
        <div class="second-row">
          <span style="font-weight: bold;">{{ option.no || 'no' }}</span>
          <span>{{ option.groupName }}</span>
        </div>
      </div>
      <div class="footer-container" slot="left-footer">
        <div class="footer-button-container">
          <el-button class="footer-button" size="small" @click="reset">
            Reset
          </el-button>
        </div>
      </div>
      <div class="footer-button-container" slot="right-footer"></div>
    </el-transfer>
  </div>
</template>

<script>
// others
import cloneDeep from 'lodash/cloneDeep'
// models
import {
  PalletSearchForm,
  PalletSearchParamsWrapUp,
  PalletStatusForCreatingInboundJobs,
  PalletStatusForCreatingOutboundJobs
} from '@/core/models/pallet'
import { InboundJob } from '@/core/models/constant'
// components
import CommonCard from '@/components/common/CommonCard.vue'
import SearchForm from '@/components/common/SearchForm.vue'
// apis
import { queryPallets } from '@/api/pallet'
export default {
  name: 'JobContentCreateWithPallet',
  props: {
    jobType: {
      type: String,
      required: true
    },
    jobPalletIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedPallets: [],
      pageSize: 10,
      loadingPalletList: false,
      palletList: [],
      searchForm: cloneDeep(PalletSearchForm)
    }
  },
  mounted() {
    this.queryPallets()
  },
  watch: {
    jobType: {
      handler() {
        const temp = cloneDeep(PalletSearchForm)
        temp.statusList.options =
          this.jobType === InboundJob
            ? Object.values(PalletStatusForCreatingInboundJobs)
            : Object.values(PalletStatusForCreatingOutboundJobs)
        temp.statusList.default = temp.statusList?.options[0] ?? 'All'
        temp.statusList.value = temp.statusList.options?.[0] ?? 'All'
        this.$set(this, 'searchForm', temp)
        this.queryPallets()
      }
      // immediate: true
    },
    jobPalletIds() {
      this.$set(this, 'selectedPallets', this.jobPalletIds)
    }
  },
  components: {
    CommonCard,
    SearchForm
  },
  computed: {
    errorMsg() {
      if (this.selectedPallets.length === 0) {
        return 'No pallets, drag one from Right panel!'
      } else {
        return ''
      }
    }
  },
  methods: {
    // ---------------------------- apis ----------------------------
    async queryPallets() {
      this.loadingPalletList = true
      const pallets = await queryPallets(
        PalletSearchParamsWrapUp(this.searchForm)
      )
      this.loadingPalletList = false
      const filteredPallets = cloneDeep(pallets)
      filteredPallets.forEach(item => {
        item.key = item.id
      })
      this.$set(this, 'palletList', filteredPallets)
    },
    searchParamChange() {
      this.queryPallets()
    },
    getSelectedPalletIds() {
      return this.palletList
        .filter(e => this.selectedPallets.includes(e.key))
        .map(p => p.id)
    },
    // ---------------------------- reset function ----------------------------
    resetJobContent() {
      this.$set(this, 'selectedPallets', [])
      this.queryPallets()
    },
    filterMethod() {},
    reset() {
      this.$set(this, 'selectedPallets', [])
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';
$draggable-list-min-height: 350px;

.job-content-create {
  @extend .f-c;

  .common-card {
    margin: 0;

    .list {
      height: 100%;
      min-height: 600px;
      gap: 10px;

      @extend .f-c;

      .draggable-list {
        flex-grow: 1;
        min-height: $draggable-list-min-height;
      }

      .pagination {
        width: 100%;
        justify-content: flex-end;

        @extend .f-r;
      }
    }
  }

  .groups {
    margin-bottom: $home-card-padding-x;
  }

  .two-draggable {
    gap: $home-card-padding-x;
  }

  .job-content,
  .pallet-list {
    width: 50%;
  }
}

.pallet-item {
  background-color: rgba(234, 236, 239, 1);
  gap: 5px;
  padding: 10px 20px;
  margin-bottom: 2px;
  border-radius: 4px;

  @extend .f-c;

  .first-row {
    font-size: $secondary-body-font-size;
    font-weight: bold;
  }

  .second-row {
    gap: 10px;
    font-size: $secondary-body-font-size;

    @extend .f-r-vc;
  }
}

.el-transfer {
  @extend .f-r;

  justify-content: space-between;
  align-items: center;

  ::v-deep .el-transfer-panel__item {
    height: auto !important;
  }

  .el-checkbox-group {
    @extend .f-c;
  }

  .item-label {
    @extend .f-c;

    flex-wrap: wrap;

    .first-row {
      gap: 10px;
      // font-size: $secondary-body-font-size;

      @extend .f-r-vc;
    }

    .second-row {
      gap: 10px;
      font-size: $secondary-body-font-size;

      @extend .f-r-vc;
    }
  }

  ::v-deep .el-transfer-panel {
    width: 45% !important;
    height: 100%;
  }

  ::v-deep .el-transfer-panel__body {
    min-height: 500px;

    @extend .f-c;

    .el-transfer-panel__list {
      flex-grow: 1;
    }
  }

  .footer-container {
    height: 100%;

    @extend .f-r;

    .footer-button {
      border: none;
      color: #409eff;
    }
  }

  ::v-deep .el-transfer__buttons {
    @extend .f-c;

    gap: 5px;
    padding: 0;

    .el-transfer__button {
      margin: 0;
    }
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.hint {
  font-size: $secondary-body-font-size;
  margin-right: 20px;
}
</style>
